import {Navigate} from "react-router-dom";
import WithoutHeaderWithoutFooter from "../compenents/without-header-without-footer";
import ErrorPage from "../pages/error";
import HomePage from "../pages/home";
import AboutPage from "../pages/about";
import ProductPage from "../pages/product";

const routes = [
    {
        path: "/",
        element: <Navigate to="/pages/index" replace={true}/>
    },
    {
        path: "/pages",
        element: <WithoutHeaderWithoutFooter/>,
        children: [
            {
                path: "index",
                element: <HomePage/>,
            },
            {
                path: "product",
                element: <ProductPage/>,
            },
            {
                path: "about",
                element: <AboutPage/>,
            },
        ],
    },
    {
        path: "*",
        element: <ErrorPage/>,
    },
]
export default routes;